import { ResponseService } from './response.service';
import { ServerResponse } from './../interfaces/server-response.model';
import { Router } from '@angular/router';
import { Observable, Subject, BehaviorSubject } from "rxjs/Rx";
import { Response } from '@angular/http';
import { ApiService } from './api.service';
import { Injectable, Output, EventEmitter } from '@angular/core';

@Injectable()
export class ActivationService {

    public activateStatus: boolean = null;

    constructor(
        private apiService: ApiService,
        private responseService: ResponseService
    ) { }

    sendActiveEmail(email) {
        return this.apiService.post('/active_email', { email: email }).map(
            (response) => {
                this.responseService.success(true, response);
                return true;
            },
            (error) => {
                this.responseService.error(error.json());
                return false;
            }
        );
    }

    activeAccount(token) {
        this.activateStatus = null;
        return this.apiService.getCSRFToken().then(csrf => this.apiService.post('/activate_account', { user_token: token }).subscribe(
            (response) => {
                this.responseService.success(true, response);
                this.activateStatus = true;
            },
            (error) => {
                this.responseService.error(error);
                this.activateStatus = false;
            }
        ));
    }
}



// WEBPACK FOOTER //
// ./src/app/services/activation.service.ts